import { FeedbackOption } from '#/types/feedback.ts';
import './FeedbackDialog.css';
import { useTranslation } from 'react-i18next';

interface FeedbackDialogProps {
  isShowing: boolean;
  isHiding: boolean;
  containerRef: React.RefObject<HTMLDivElement | null>;
  dialogRef: React.RefObject<HTMLDivElement | null>;
  selectedReasons: string[];
  otherReason: string;
  showOtherInput: boolean;
  onFeedbackReason: (reason: string) => void;
  onOtherReasonChange: (value: string) => void;
  onShowOtherInput: (show: boolean) => void;
  onHideFeedback: () => void;
}

export function FeedbackDialog({
  isShowing,
  isHiding,
  containerRef,
  dialogRef,
  selectedReasons,
  otherReason,
  showOtherInput,
  onFeedbackReason,
  onOtherReasonChange,
  onShowOtherInput,
  onHideFeedback
}: FeedbackDialogProps) {
  const { t } = useTranslation();

  const getFeedbackOptionLabel = (option: string): string => {
    const labels: Record<string, string> = {
      [FeedbackOption.INCORRECT_INFO]: t("incorrectInfo"),
      [FeedbackOption.INCORRECT_IMAGES]: t("incorrectImages"),
      [FeedbackOption.TOO_DIFFICULT]: t("tooDifficult"),
      [FeedbackOption.TOO_SIMPLE]: t("lacksDetail"),
      [FeedbackOption.NO_ANSWER]: t("noAnswer"),
      [FeedbackOption.PRONUNCIATION]: t("pronunciation"),
      [FeedbackOption.INCORRECT_METADATA]: t("incorrectMetadata"),
      [FeedbackOption.MISSING_ALERTS]: t("missingAlerts"),
      [FeedbackOption.CHECKLIST_NEEDED]: t("checklistNeeded"),
      [FeedbackOption.OTHER]: t("otherReason")
    };
    return labels[option] || option;
  };

  return (
    <div 
      className={`feedbackDialogContainer ${isShowing ? 'showing' : ''} ${isHiding ? 'hiding' : ''}`} 
      ref={containerRef}
    >
      <div className="feedbackDialog" ref={dialogRef}>
        <div className="feedbackHeader">
          <div className="headerContent">
            <span className={`feedbackThankYou ${(selectedReasons.length > 0 || otherReason.length > 0) ? 'visible' : ''}`}>
              {t("thanksForFeedback")}
            </span>
            <button className="closeBtn" onClick={onHideFeedback}>✕</button>
          </div>
        </div>
        <div className="feedbackTitle">{t("whatWentWrong")}</div>
        {!showOtherInput ? (
          <>
            {/* Feedback buttons */}
            {Object.values(FeedbackOption).map((option) => (
              <button 
                key={option}
                onClick={() => onFeedbackReason(option)}
                className={selectedReasons.includes(option) ? "selected" : ""}
              >
                {getFeedbackOptionLabel(option)}
              </button>
            ))}
          </>
        ) : (
          <>
            <textarea
              className="otherReasonInput"
              placeholder={t("pleaseAddDetails")}
              value={otherReason}
              onChange={(e) => onOtherReasonChange(e.target.value)}
              autoFocus
            />
            <button 
              onClick={() => onShowOtherInput(false)}
              className="backButton"
              style={{ gridColumn: '1 / -1' }}
            >
              {otherReason.length > 0 ? t('save') : t('back')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
